<div class="d-flex" *ngIf="user">
    <img class="flex-shrink-0 rounded-circle"
         [matTooltip]="tooltip ? tooltip : user.name"
         [src]="user.picturePublicUrl"
         [width]="size"
         [height]="size"
         [style.object-fit]="'cover'"
         *ngIf="user?.picturePublicUrl"/>
    <div class="small-text flex-grow-1" *ngIf="!user?.picturePublicUrl">{{user.name}}</div>
</div>